import { StarOutlineRounded, StarRounded } from "@mui/icons-material";
import { IconButton, type IconButtonProps, styled } from "@mui/material";
import { useState } from "react";

const StyledIconFavorite = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>(({ theme, color = "primary", active }) => ({
  width: 24,
  height: 24,
  color: active ? theme.palette[color].main : theme.palette.secondary.main,
  "& .MuiSvgIcon-root:hover": {
    color: active ? theme.palette[color].dark : theme.palette.secondary.main,
    transition: "all 0.30s ease",
  },
  "&:disabled": {
    color: theme.palette.secondary[50],
  },
}));

export function IconFavorite({
  color = "primary",
  onClick,
  ...props
}: IconButtonProps) {
  const [active, setActive] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setActive((prevValue) => !prevValue);
    onClick?.(event);
  };

  return (
    <StyledIconFavorite
      disableRipple
      disableFocusRipple
      {...props}
      active={active}
      onClick={handleClick}
    >
      {active ? <StarRounded /> : <StarOutlineRounded />}
    </StyledIconFavorite>
  );
}
